// extracted by mini-css-extract-plugin
export default {"title":"CookiesPolicy_title__tKdZ8","table":"CookiesPolicy_table__+9kbD"};